import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { SpinnerService } from '../../services/spinner.service';
import { CommonToastService } from '../../services/common-toast.service';
import { MESSAGE_CATEGORY_CONSTATNS } from '../../constants/constant';
import { ServiceOrderService } from 'src/app/all-modules/service-order/services/service-order.service';
import { accountingDashboardViewModel } from 'src/app/all-modules/accounting/models/accounting.model';
import { accountCoordinatorDashboardData } from 'src/app/all-modules/service-order/models/service-order.model';
import moment from 'moment';
import { ApiResponse } from '../../common-model/common.model';

@Component({
    selector: 'app-dashboard-account-coordinator',
    templateUrl: './dashboard-account-coordinator.component.html',
    styleUrl: './dashboard-account-coordinator.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardAccountCoordinatorComponent {
  acDashboardInfo!: accountCoordinatorDashboardData;
  isReadyToSentToClientClearDialog = false;
  isLoadingReadyToSentToClientClear = false;
  readyToSentToClientSoList: string[] = [];
  constructor(
    private router: Router,
    private soService: ServiceOrderService,
    private commonService: CommonService,
    private spinnerService: SpinnerService,
    private commonToastService: CommonToastService
  ) {
    this.commonService.navigateToDashboardByRoleKey();
  }
  ngOnInit() {

    this.getACCDashboardInfo();
  }
  getACCDashboardInfo() {
    this.spinnerService.show();
    this.soService.getAccountCoordinatorDashboard().subscribe({
      next: (response: accountCoordinatorDashboardData) => {
        this.acDashboardInfo = response;
        this.readyToSentToClientSoList = this.acDashboardInfo.readyToSentToClientSoList;
        this.spinnerService.hide();
      },
      error: (error) => {
        this.spinnerService.hide();
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.ACCOUNT_COORDINATOR, error?.message);
        }
      }
    });
  }
  openSendRemiderToClientDialog() {
    this.isReadyToSentToClientClearDialog = true;
  }
  closeSendRemiderToClientDialog() {
    this.isReadyToSentToClientClearDialog = false;
  }
  soReadyToSentToClientClear() {
    
    this.isLoadingReadyToSentToClientClear = true;
    this.soService.soReadyToSentToClientClear(this.readyToSentToClientSoList).subscribe({
      next: (response: ApiResponse) => {
        this.commonToastService.showToasterMessage(response.msgCategoryKey, response.msgCategoryTitle, response.message);
        this.isLoadingReadyToSentToClientClear = false;
        this.closeSendRemiderToClientDialog();
        this.getACCDashboardInfo();
      },
      error: (error) => {
        this.isLoadingReadyToSentToClientClear = false;
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
        }
      }
    });
  }
  navigateToWONSOList() {
    let url = "so/list?iswon=true";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  navigateToWithEstimatorSOList() {
    let url = "so/list?withestimator=true";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  navigateToReadySOList() {
    let url = "so/list?isready=true";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  navigateToSOList(key: string) {
    let url = "so/list?" + key + "=true";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
}
